import zipObject from 'lodash/zipObject';

/*
 * App actions
 */

const ACTIONS = [
  'SIGN_IN',
  'SIGN_IN_SUCCESS',
  'SIGN_IN_FAILURE',

  'SIGN_UP',
  'SIGN_UP_SUCCESS',
  'SIGN_UP_FAILURE',

  'SIGN_OUT',

  'SEND_RESET_PASSWORD_EMAIL',
  'SEND_RESET_PASSWORD_EMAIL_SUCCESS',
  'SEND_RESET_PASSWORD_EMAIL_FAILURE',

  'RESET_PASSWORD',
  'RESET_PASSWORD_SUCCESS',
  'RESET_PASSWORD_FAILURE',

  'VERIFY_EMAIL',
  'VERIFY_EMAIL_SUCCESS',
  'VERIFY_EMAIL_FAILURE',

  'GET_ACCOUNT_INFO',
  'GET_ACCOUNT_INFO_SUCCESS',
  'GET_ACCOUNT_INFO_FAILURE',

  'UPDATE_ACCOUNT_INFO',
  'UPDATE_ACCOUNT_INFO_SUCCESS',
  'UPDATE_ACCOUNT_INFO_FAILURE',

  'ADD_PAYMENT_METHOD_REQUEST',
  'ADD_PAYMENT_METHOD_SUCCESS',
  'ADD_PAYMENT_METHOD_FAILURE',

  'DELETE_PAYMENT_METHOD_REQUEST',
  'DELETE_PAYMENT_METHOD_SUCCESS',
  'DELETE_PAYMENT_METHOD_FAILURE',

  'DOWNLOAD_ORDER_POLICY',
  'DOWNLOAD_ORDER_POLICY_SUCCESS',
  'DOWNLOAD_ORDER_POLICY_FAILURE',

  'GET_CLAIMS_HISTORY',
  'GET_CLAIMS_HISTORY_SUCCESS',
  'GET_CLAIMS_HISTORY_FAILURE',

  'GET_CLAIMS_PROCESS',
  'GET_CLAIMS_PROCESS_SUCCESS',
  'GET_CLAIMS_PROCESS_FAILURE',

  'MAGIC_LINK_SIGN_IN_SUCCESS',

  'START_CLAIM',

  'SAVE_CLAIMS_DEVICE_DAMAGES',
  'SAVE_CLAIMS_DEVICE_DAMAGE_DESCRIPTION',
  'SAVE_CLAIMS_DEVICE_SERIAL_NUMBER',
  'SAVE_CLAIMS_DEVICE_METHOD',

  'SUBMIT_CLAIM',
  'SUBMIT_CLAIM_SUCCESS',
  'SUBMIT_CLAIM_FAILURE',

  'SAVE_BANK_ACCOUNT',
  'SAVE_BANK_ACCOUNT_SUCCESS',
  'SAVE_BANK_ACCOUNT_FAILURE',

  'GET_L10N',
  'GET_L10N_SUCCESS',
  'GET_L10N_FAILURE',

  'SAVE_BAGGAGE_LOCATION',
  'SAVE_BAGGAGE_AIRLINE',
  'SAVE_BAGGAGE_CONFIRMATION_NUMBER',
  'SAVE_BAGGAGE_PASSENGER_INFO',

  'SELECT_BAGGAGE_PLAN',

  'CHECKOUT_BAGGAGE',
  'CHECKOUT_BAGGAGE_SUCCESS',
  'CHECKOUT_BAGGAGE_FAILURE',

  'PURCHASE_BAGGAGE',
  'PURCHASE_BAGGAGE_SUCCESS',
  'PURCHASE_BAGGAGE_FAILURE',

  'GET_BAGGAGE_PLANS',
  'GET_BAGGAGE_PLANS_SUCCESS',
  'GET_BAGGAGE_PLANS_FAILURE',

  'GET_AIRLINES',
  'GET_AIRLINES_SUCCESS',
  'GET_AIRLINES_FAILURE',

  'SELECT_COLLECTIBLES_ENDORSEMENT_CHOICE',
  'SAVE_COLLECTIBLES_ENDORSEMENT_RESPONSE',
  'DELETE_COLLECTIBLES_ENDORSEMENT_RESPONSE',
  'UPDATE_COLLECTIBLES_ENDORSEMENT_CURRENT_RESPONSE',
  'COLLECTIBLES_ENDORSEMENT_SURVEY_NEXT',
  'COLLECTIBLES_ENDORSEMENT_SURVEY_BACK',

  'GET_COLLECTIBLES_ENDORSEMENT_ADD_FORM',
  'GET_COLLECTIBLES_ENDORSEMENT_ADD_FORM_SUCCESS',
  'GET_COLLECTIBLES_ENDORSEMENT_ADD_FORM_FAILURE',

  'GET_COLLECTIBLES_ENDORSEMENT_ADD_CHECKOUT',
  'GET_COLLECTIBLES_ENDORSEMENT_ADD_CHECKOUT_SUCCESS',
  'GET_COLLECTIBLES_ENDORSEMENT_ADD_CHECKOUT_FAILURE',

  'GET_COLLECTIBLES_ENDORSEMENT_EDIT_FORM',
  'GET_COLLECTIBLES_ENDORSEMENT_EDIT_FORM_SUCCESS',
  'GET_COLLECTIBLES_ENDORSEMENT_EDIT_FORM_FAILURE',

  'GET_COLLECTIBLES_ENDORSEMENT_EDIT_CHECKOUT',
  'GET_COLLECTIBLES_ENDORSEMENT_EDIT_CHECKOUT_SUCCESS',
  'GET_COLLECTIBLES_ENDORSEMENT_EDIT_CHECKOUT_FAILURE',

  'GET_COLLECTIBLES_ENDORSEMENT_REMOVE_CHECKOUT',
  'GET_COLLECTIBLES_ENDORSEMENT_REMOVE_CHECKOUT_SUCCESS',
  'GET_COLLECTIBLES_ENDORSEMENT_REMOVE_CHECKOUT_FAILURE',

  'UPDATE_COLLECTIBLES_ENDORSEMENT_ADDRESS',

  'PURCHASE_COLLECTIBLES_ENDORSEMENT_ADD',
  'PURCHASE_COLLECTIBLES_ENDORSEMENT_ADD_SUCCESS',
  'PURCHASE_COLLECTIBLES_ENDORSEMENT_ADD_FAILURE',
  'PURCHASE_COLLECTIBLES_ENDORSEMENT_EDIT',
  'PURCHASE_COLLECTIBLES_ENDORSEMENT_EDIT_SUCCESS',
  'PURCHASE_COLLECTIBLES_ENDORSEMENT_EDIT_FAILURE',
  'SUBMIT_COLLECTIBLES_ENDORSEMENT_REMOVE',
  'SUBMIT_COLLECTIBLES_ENDORSEMENT_REMOVE_SUCCESS',
  'SUBMIT_COLLECTIBLES_ENDORSEMENT_REMOVE_FAILURE',

  'RESET_COLLECTIBLES_ENDORSEMENT_DATA',

  'GET_COLLECTIBLES_CATEGORIES',
  'GET_COLLECTIBLES_CATEGORIES_SUCCESS',
  'GET_COLLECTIBLES_CATEGORIES_FAILURE',

  'START_RENTAL_CAR_EXTENSION',
  'UPDATE_RENTAL_CAR_EXTENSION_CONFIRMATION_NUMBER',

  'GET_RENTAL_CAR_EXTENSION_POLICY',
  'GET_RENTAL_CAR_EXTENSION_POLICY_SUCCESS',
  'GET_RENTAL_CAR_EXTENSION_POLICY_FAILURE',

  'GET_RENTAL_CAR_EXTENSION_CHECKOUT',
  'GET_RENTAL_CAR_EXTENSION_CHECKOUT_SUCCESS',
  'GET_RENTAL_CAR_EXTENSION_CHECKOUT_FAILURE',

  'PURCHASE_RENTAL_CAR_EXTENSION',
  'PURCHASE_RENTAL_CAR_EXTENSION_SUCCESS',
  'PURCHASE_RENTAL_CAR_EXTENSION_FAILURE',

  'GET_POLICIES_FOR_ALL_VERTICALS',
  'GET_POLICIES_FOR_ALL_VERTICALS_SUCCESS',
  'GET_POLICIES_FOR_ALL_VERTICALS_FAILURE',

  'GET_POLICIES_FOR_VERTICAL',
  'GET_POLICIES_FOR_VERTICAL_SUCCESS',
  'GET_POLICIES_FOR_VERTICAL_FAILURE',

  'GET_POLICY_BY_ID',
  'GET_POLICY_BY_ID_SUCCESS',
  'GET_POLICY_BY_ID_FAILURE',

  'GET_CANCEL_POLICY_CHECKOUT',
  'GET_CANCEL_POLICY_CHECKOUT_SUCCESS',
  'GET_CANCEL_POLICY_CHECKOUT_FAILURE',

  'CANCEL_POLICY',
  'CANCEL_POLICY_SUCCESS',
  'CANCEL_POLICY_FAILURE',

  'SHOW_MENU',
  'HIDE_MENU',

  'SHOW_TOAST',
  'HIDE_TOAST',

  'SHOW_GLOBAL_MODAL',
  'HIDE_GLOBAL_MODAL',
];

const ACTION_TYPES = zipObject(ACTIONS, ACTIONS);

/*
 * Third-party actions
 */

ACTION_TYPES.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

export default ACTION_TYPES;
